module.exports = __webpack_public_path__ + "assets/img/transition_back.c2b4a4ca.png";